const RNFetchBlob = {
  DocumentDir: () => {},
  polyfill: () => {},
};

export { RNFetchBlob };
